import React, { Fragment, useEffect, useState } from 'react';
import Modal from 'react-modal';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import aImg from '../../images/about/NEW/team.png';
import PolicySection from './Policy';
import WhyUs from './WhyUs';
import FeaturesSection from '../../components/FeaturesSection/FeaturesSection';
import CtaSection from '../../components/CtaSection/CtaSection';
import localVideo from '../../images/about/NEW/Liam.mp4';
import teamW from '../../images/about/NEW/team-white.png';
//import teamB from '../../images/about/NEW/team-blue.png';
//import teamG from '../../images/about/NEW/team-grad.png';
//import teamB from '../../images/about/NEW/team-blue.png';
//import teamG from '../../images/about/NEW/team-grad.png';

Modal.setAppElement('#root');

const AboutUsPage = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        window.scrollTo(10, 0);
    }, []);

    return (
        <Fragment>
            <main className="page_content about-page">
                <PageTitle pageTitle="About Us" pagesub="" pageTop="" />

                <section className="intro_about_section  bg-light ">
                    <div className="container">
                        <div className="row align-items-center gy-4">
                            <div className="col-lg-8">
                                <div className="image_wrap">
                                    <img
                                        src={aImg}
                                        loading='lazy'
                                        alt="Laskon Technologies - About"
                                        className="img-fluid rounded shadow"
                                    />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="image_wrap position-relative">
                                    <img
                                        src={teamW}
                                        className="img-fluid rounded shadow"
                                        alt="Laskon Technologies Team"
                                          loading='lazy'
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            objectFit: 'cover',
                                            borderRadius: '12px',
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="mt-5">
                            <div className="row justify-content-between align-items-start">
                                <div className="col-lg-4" style={{ "textAlign": "center" }} >

                                    <h2 className="heading_text mb-3 fs-2 fw-bold">
                                        We Provide You Flexible Services
                                    </h2>
                                </div>
                                <div className="col-lg-8">
                                    <p className="heading_description lead text-muted m-15px" style={{ "textAlign": "justify" }}>
                                        Laskon Technologies provides adaptable IT solutions that evolve with your business. From software development to strategic consulting, our services drive growth, improve efficiency, and support your digital transformation.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <PolicySection />
                <FeaturesSection />
                <WhyUs />
                <CtaSection />
            </main>

            <Scrollbar />

            {/* Video Modal */}
            <Modal
                isOpen={isOpen}
                onRequestClose={() => setIsOpen(false)}
                contentLabel="Watch Video"
                style={{
                    content: {
                        inset: 'auto',
                        margin: 'auto',
                        width: '80%',
                        maxWidth: '720px',
                        background: '#000',
                        border: 'none',
                        borderRadius: '12px',
                        padding: '0',
                        overflow: 'hidden',
                    },
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.85)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9998,
                    },
                }}
            >
                <video width="100%" controls autoPlay style={{ borderRadius: '8px' }}>
                    <source src={localVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </Modal>
        </Fragment>
    );
};

export default AboutUsPage;